import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

export const ComponentsDiv = styled(BaseStyles.ComponentsDiv)`
    bottom: 0rem;
`

export const ViewerDiv = styled(BaseStyles.Div)`
    margin: 0rem auto;
    padding: 0rem 2rem;
    min-width: 20rem;
    max-width: 120rem;
`